import { Mapper } from "lib/api";
import { Containment, ContainmentDTO } from "models";

// first param is the DTO, second param is the class
export class ContainmentMapper extends Mapper<ContainmentDTO, Containment> {
	constructor() {
		super(Containment); // Pass the target class constructor
	}

	// Override only if you need custom mapping logic beyond plainToClass
	// protected override customMapping(source: ContainmentDTO, target: Containment): Containment {
	// 	return target.SetSector(source.sector)
	// }
}

export function New(): ContainmentMapper {
	return new ContainmentMapper();
}
